import { ArrowUpRight, Ruler } from "lucide-react";
import type { ProductMatch } from "../lib/types";

const formatEuro = (cents: number) =>
  new Intl.NumberFormat("hr-HR", { style: "currency", currency: "EUR" }).format(cents / 100);

export function ProductCard({ match }: { match: ProductMatch }) {
  const { product } = match;
  return (
    <article className="product-card">
      <div className="product-card__image">
        <img src={product.imageUrl} width="320" height="220" alt="" loading="lazy" />
        <span className={`match-level match-level--${match.level.toLowerCase().replace(" ", "-")}`}>
          {match.level}
        </span>
      </div>
      <div className="product-card__body">
        <p className="product-card__store">{product.store} · demo katalog</p>
        <h3>{product.title}</h3>
        <div className="product-card__price">
          <strong>{formatEuro(product.priceCents)}</strong>
          {product.previousPriceCents && <del>{formatEuro(product.previousPriceCents)}</del>}
        </div>
        {(product.widthCm || product.depthCm || product.heightCm) && (
          <p className="product-card__dimensions">
            <Ruler aria-hidden="true" />
            {[product.widthCm, product.depthCm, product.heightCm].filter(Boolean).join(" × ")} cm
          </p>
        )}
        <p className="product-card__reason">{match.explanation.slice(0, 3).join(" · ")}</p>
        <p className="product-card__checked">Zadnja demo provjera: 24. 7. 2026.</p>
        <a
          className="button button--outline button--full"
          href={product.productUrl}
          target="_blank"
          rel="noreferrer"
        >
          Pogledaj u trgovini
          <ArrowUpRight aria-hidden="true" />
        </a>
      </div>
    </article>
  );
}
